<template lang='pug'>
  .gifts-container
    heading-section(:title='title', :description='description', :hideDescription='hideDescription')
    .gifts
      .gift
        .img.img-bday(:style='headerSectionStyle("bday")', ref='headerSection' class='new-gift-banner')
        .title(v-text='$t("bday")')
        .description(v-text='$t("bdayDesc")')
      .gift
        .img.img-upgrade(:style='headerSectionStyle("upgrade")', ref='headerSection' class='new-gift-banner')
        .title(v-text='$t("tier")')
        .description(v-text='$t("tierDesc")')
</template>

<i18n>
{
  "lng_en": {
    "bday": "birthday",
    "bdayDesc": "Enjoy 2x bonus points on one purchase during your birthday month",
    "tier": "tier upgrade",
    "tierDesc": "Receive an exclusive Beauty Pass gift with each tier upgrade"
  },
  "lng_id": {
    "bday": "ulang tahun",
    "bdayDesc": "Nikmati bonus 2x poin untuk satu pembelian dalam bulan ulang tahun Anda",
    "tier": "upgrade tier",
    "tierDesc": "Dapatkan hadiah Beauty Pass eksklusif untuk setiap kenaikan tier"
  },
  "lng_th": {
    "bday": "วันเกิด",
    "bdayDesc": "รับคะแนนเพิ่ม 2 เท่า เมื่อคุณซื้อสินค้าภายในเดือนเกิดของคุณ ",
    "tier": "อัปเกรดระดับ",
    "tierDesc": "รับของขวัญสุดพิเศษจาก Beauty Pass เมื่ออัปเกรดแต่ละระดับ"
  },
  "lng_zh": {
    "bday": "生日",
    "bdayDesc": "生日月單次購物可尊享2x積分。",
    "tier": "升級會籍",
    "tierDesc": "每次升級會籍可獲獨家Beauty Pass禮遇。"
  },
  "lng_ko": {
    "bday": "생일",
    "bdayDesc": "생일이 있는 달에 구매하시고 2배 보너스 포인트를 적립 받으세요(적립 횟수 1회 제한)",
    "tier": "등급 업그레이드",
    "tierDesc": "등급 업그레이드마다 특별한 뷰티 패스 선물을 받을 수 있습니다"
  }
}
</i18n>

<script>
import HeadingSection from './heading.vue'

export default {
  components: {
    HeadingSection
  },
  props: [
    'title',
    'description',
    'birthdayImageUrl',
    'tierUpgradeImageUrl',
    'hideDescription'
  ],

  data () {
    return {
      country: null,
      headerWidth: 1200
    }
  },

  methods: {
    headerSectionStyle (icon) {
      if (icon === 'bday') {
        return Object.assign(
          { backgroundImage: `url(${this.birthdayImageUrl})` },
          this.heroPosition
        )
      } else {
        return Object.assign(
          { backgroundImage: `url(${this.tierUpgradeImageUrl})` },
          this.heroPosition
        )
      }
    }
  }
}

</script>

<style lang='scss' scoped>
  .gifts-container {
    padding-bottom: 30px;
    padding-top: 30px;

    @include media-breakpoint-up(xl) {
      align-content: space-between;
      display: flex;
      flex-flow: column-reverse wrap;
      height: 350px;
      justify-content: center;
      margin: 0 auto;
    }

    > .gifts {
      display: flex;
      justify-content: space-around;
      margin: 20px auto 0;

      @include media-breakpoint-up(sm) {
        justify-content: space-between;
        width: 550px;
      }
    }
  }

  .gifts {
    > .gift {
      width: 46%;

      @include media-breakpoint-up(sm) {
        width: 250px;
      }
    }
  }

  .gift {
    > .img {
      margin-bottom: 8px;

      height: 115px;
      width: 100%;

      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;

      @include media-breakpoint-up(sm) {
        height: 170px;
        margin-bottom: 15px;
      }
    }

    > .title {
      @include font-weight-medium;
      text-transform: uppercase;
    }
  }

  .img-upgrade.new-gift-banner {
    background-image: url('../../../assets/images/account/beauty_pass/Benefits_Icon-17.png');
  }

  .img-bday.new-gift-banner {
    background-image: url('../../../assets/images/account/beauty_pass/REG_BPRef_BPPG_Web_2X_2.jpg');
  }
</style>
